/* Mubi Leather hero carousel — cross-fade slides, respects prefers-reduced-motion. */
(() => {
  const init = (root) => {
    if (root.dataset.mubiHeroReady === 'true') return;
    root.dataset.mubiHeroReady = 'true';

    const slides = [...root.querySelectorAll('.mubi-hero__slide')];
    const copies = [...root.querySelectorAll('.mubi-hero__copy')];
    const dots = [...root.querySelectorAll('.mubi-hero__dots button')];
    if (slides.length < 2) return;

    const still = window.matchMedia('(prefers-reduced-motion: reduce)');
    const wantsAutoplay = root.dataset.autoplay === 'true';
    const interval = (parseInt(root.dataset.interval, 10) || 6) * 1000;
    let index = 0;
    let timer = null;

    const show = (next) => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
      copies.forEach((copy, i) => copy.classList.toggle('is-active', i === index));
      dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
    };

    const start = () => {
      clearInterval(timer);
      if (wantsAutoplay && !still.matches) timer = setInterval(() => show(index + 1), interval);
    };

    dots.forEach((dot, i) => dot.addEventListener('click', () => { show(i); start(); }));
    root.querySelector('.mubi-hero__arrow--prev')?.addEventListener('click', () => { show(index - 1); start(); });
    root.querySelector('.mubi-hero__arrow--next')?.addEventListener('click', () => { show(index + 1); start(); });
    still.addEventListener('change', start);
    root.addEventListener('mouseenter', () => clearInterval(timer));
    root.addEventListener('mouseleave', start);

    start();
  };

  const boot = () => document.querySelectorAll('.mubi-hero').forEach(init);
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
  boot();
})();
